import React from "react";
import {
  format,
  startOfMonth,
  endOfMonth,
  eachDayOfInterval,
  startOfWeek,
  endOfWeek,
  isSameMonth,
} from "date-fns";
import { useSelector } from "react-redux";

const Calendar = () => {
  const user = useSelector((state) => state.user.data);

  const dates = (user.wishDates || []).map((date) => format(new Date(date), "yyyy-MM-dd"));

  const today = new Date();
  const start = startOfWeek(startOfMonth(today));
  const end = endOfWeek(endOfMonth(today));
  const daysInCalendar = eachDayOfInterval({ start, end });

  const formatDate = (date) => format(date, "yyyy-MM-dd");

  return (
    <div className="p-4 max-w-md mx-auto bg-white shadow-lg rounded-lg">
      <h2 className="text-l font-bold text-center mb-4">
        Days you made your wishes
      </h2>

      <div className="grid grid-cols-7 gap-2">
        {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
          <div key={day} className="text-gray-600 font-semibold text-center">
            {day}
          </div>
        ))}
        {daysInCalendar.map((day) => (
          <div
            key={formatDate(day)}
            className={`w-10 h-10 flex items-center justify-center rounded-lg ${
              dates.includes(formatDate(day)) ? "bg-red-500 text-white" : "text-gray-700"
            } ${!isSameMonth(day, today) && "opacity-50"}`}
          >
            {format(day, "d")}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Calendar;
